<template>
  <div>
    <header class="modal-header">
      <h3 class="modal-title">Settings</h3>
    </header>
    <div class="modal-body">
      <b-form>
        <b-form-group
          label="Pricing per car (per month):"
          label-for="code">
          <b-form-input
            id="code"
            v-model="setting.WASH_PRICE_PER_CAR"
            type="text"
            required/>
        </b-form-group>
        <b-form-group
          label="Wash budget per month:"
          label-for="code">
          <b-form-input
            id="code"
            v-model="setting.WASH_BUDGET_PER_MONTH"
            type="text"
            required/>
        </b-form-group>
      </b-form>
    </div>
    <footer class="modal-footer">
      <b-btn
        :size="'sm'"
        @click="$emit('close')">Cancel</b-btn>
      <b-btn
        :variant="'primary'"
        :size="'sm'"
        :disabled="isFetching"
        @click="handleSubmit">Submit</b-btn>
    </footer>
  </div>
</template>
<script>
import server from '@/services/server'

export default {
  name: 'SettingsModal',
  props: {
    model: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      setting: {...this.model},
      isFetching: false
    }
  },
  methods: {
    handleSubmit (e) {
      e.preventDefault()
      this.isFetching = true

      let payload = {
        washPricePerCar: this.setting.WASH_PRICE_PER_CAR,
        washBudgetPerMonth: this.setting.WASH_BUDGET_PER_MONTH,
        wpStartDay: this.setting.WP_START_DAY,
        wpStartTime: this.setting.WP_START_TIME,
        wpEndDay: this.setting.WP_END_DAY,
        wpEndTime: this.setting.WP_END_TIME
      }

      server.post('/ops/updateGenerics', [payload]).then(
        () => {
          this.isFetching = false
          this.$emit('close')
        },
        () => {
          this.isFetching = false
        }
      )
    }
  }
}
</script>
